var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSequenceNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14829 5.23617L5.14826 5.23616C4.77243 5.07443 4.35045 5.14228 4.0356 5.42488L5.14829 5.23617ZM5.14829 5.23617L19.6711 11.485L19.928 10.8879M5.14829 5.23617L19.928 10.8879M19.928 10.8879L19.6711 11.485C20.0842 11.6627 20.35 12.0594 20.35 12.5526C20.35 13.0459 20.0842 13.4426 19.6711 13.6203L19.928 14.2174L19.6711 13.6203L5.1483 19.8691C4.77293 20.0306 4.35088 19.9635 4.03557 19.6804L4.03556 19.6804M19.928 10.8879L4.03556 19.6804M4.03556 19.6804C3.71736 19.3947 3.57823 18.9493 3.68595 18.5113L3.055 18.3561M4.03556 19.6804L3.055 18.3561M3.055 18.3561L3.68595 18.5113L5.11308 12.7078L5.15125 12.5526M3.055 18.3561L5.15125 12.5526M5.15125 12.5526L5.11308 12.3974M5.15125 12.5526L5.11308 12.3974M5.11308 12.3974L3.68595 6.59399L3.68595 6.59399M5.11308 12.3974L3.68595 6.59399M3.68595 6.59399C3.57824 6.15603 3.71736 5.71061 4.03556 5.42491L3.68595 6.59399Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequenceNavIcon);
export default __webpack_public_path__ + "static/media/sequenceNavIcon.b820b7cc17f6c7e6f27a88c3d0ea88e5.svg";
export { ForwardRef as ReactComponent };